import {
  ComplianceKycsClient,
  VerificationStatusData,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";
import Logger from "../utils/logger";

const complianceKycsClient = new ComplianceKycsClient(
  apiConfig,
  undefined,
  axiosInstance
);

const getUserVerificationStatus = async (): Promise<
  VerificationStatusData | undefined
> => {
  try {
    const verificationStatusData = (
      await complianceKycsClient.getUserVerificationStatus()
    ).data;
    return verificationStatusData;
  } catch (error) {
    Logger.log(error);
  }
};

export { getUserVerificationStatus };
